const stepFieldConfig = [
    {
        label: "Method",
        key: "type",
        type: "dropdown",
        options: ["GET", "POST", "PUT", "DELETE"]
    },
    {
        label: "URL",
        key: "url",
        type: "text"
    },
    {
        label: "Auth",
        key: "auth",
        type: "dropdown",
        dynamic: true,
        options: ["+ Create New"]
    },
    {
        label: "Return Type",
        key: "returnType",
        type: "dropdown",
        options: ["Array", "Single Object", "Single Value (not JSON)"]
    }
];

const commonFieldOptionEnums = {
    CONNECTED: "+ Create New Connect Field",
    PREDEFINED: "Predefined",
    CREATE_NEW: "+ Create New"
};

const fieldNameEnums = {
    CONNECTED_FIELD: "connectFieldName",
    EXTRA_FIELD: "extraFieldName",
    PREDEFINED_FIELD: "predefinedValue",
    RETURN_FIELD: "returnFieldName",
    FIELD_VALUE: "fieldValue",
    RETURN_VALUE: "returnValue"
};

const calledFromEnums = {
    API_PAGE: "api page",
    AUTH_POPUP: "auth popup"
};

const authCategories = {
    headers: "Header Fields",
    params: "Params Fields",
    body: "Body Fields"
};

const categories = {
    ...authCategories,
    returnFields: "Return Fields"
};

const authTypeEnums = {
    BEARER_TOKEN: "Bearer Token",
    NO_AUTH: "No Auth"
};

const apiActions = {
    CREATE: "create",
    EDIT: "edit"
};

export {
    categories,
    stepFieldConfig,
    commonFieldOptionEnums,
    fieldNameEnums,
    calledFromEnums,
    authCategories,
    authTypeEnums,
    apiActions
};
